/*
  Javascript integers are 53 bit long. for longer codes change to:
  https://github.com/vukicevic/crunch
*/
//import { strict as assert } from 'assert';
const version = "1.3.0";

export const ABC = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  // 'I',
  "J",
  "K",
  "L",
  "M",
  "N",
  // 'O',
  "P",
  // 'Q',
  "R",
  "S",
  "T",
  // 'U',
  "V",
  // 'W',
  // 'X',
  // 'Y',
  // 'Z'
];

const rnd46x512 = [
  36, 17, 3, 6, 13, 2, 14, 3, 32, 28, 30, 4, 23, 44, 20, 43, 40, 45, 16, 29, 22,
  30, 0, 39, 6, 28, 30, 29, 34, 29, 15, 14, 8, 2, 23, 20, 2, 42, 5, 0, 43, 42,
  12, 36, 23, 43, 23, 5, 1, 6, 1, 35, 12, 34, 19, 5, 16, 14, 14, 37, 35, 33, 45,
  24, 2, 22, 35, 40, 43, 21, 32, 27, 21, 33, 0, 2, 43, 1, 6, 0, 21, 43, 16, 1,
  38, 2, 36, 33, 0, 5, 1, 39, 21, 9, 28, 2, 21, 34, 3, 44, 19, 19, 8, 9, 38, 33,
  26, 35, 23, 18, 1, 30, 45, 1, 39, 39, 13, 45, 39, 41, 29, 24, 45, 36, 35, 10,
  40, 27, 1, 38, 25, 3, 39, 20, 36, 8, 18, 32, 26, 11, 21, 23, 29, 45, 0, 26,
  12, 3, 38, 45, 23, 14, 24, 14, 44, 19, 18, 26, 20, 2, 36, 3, 0, 45, 8, 9, 34,
  13, 28, 13, 27, 2, 27, 40, 15, 19, 32, 25, 40, 18, 12, 26, 8, 24, 20, 34, 16,
  37, 7, 34, 27, 43, 24, 45, 35, 10, 43, 10, 17, 26, 10, 20, 27, 33, 20, 23, 24,
  30, 26, 22, 14, 38, 31, 11, 37, 5, 44, 15, 8, 45, 5, 12, 20, 0, 43, 39, 29,
  36, 26, 43, 7, 31, 36, 34, 21, 25, 30, 38, 24, 27, 27, 3, 4, 10, 33, 16, 23,
  5, 5, 16, 35, 23, 0, 6, 27, 36, 40, 0, 25, 2, 6, 36, 44, 32, 39, 5, 45, 43,
  24, 22, 39, 28, 33, 10, 43, 29, 32, 12, 8, 10, 29, 12, 34, 31, 15, 15, 19, 36,
  22, 43, 10, 12, 10, 13, 36, 28, 45, 25, 9, 44, 36, 13, 28, 9, 35, 7, 45, 26,
  13, 23, 31, 28, 18, 34, 42, 17, 14, 37, 32, 32, 6, 20, 23, 34, 37, 42, 16, 41,
  23, 9, 4, 12, 18, 13, 29, 1, 1, 37, 44, 32, 36, 14, 30, 15, 36, 14, 1, 20, 19,
  1, 35, 26, 41, 45, 3, 40, 9, 40, 39, 25, 4, 39, 42, 2, 17, 42, 24, 23, 40, 10,
  41, 28, 31, 39, 28, 11, 23, 24, 39, 45, 27, 35, 12, 33, 15, 2, 44, 41, 42, 0,
  33, 1, 38, 22, 23, 31, 37, 15, 25, 44, 36, 33, 34, 3, 9, 9, 12, 35, 3, 22, 3,
  11, 0, 35, 41, 26, 29, 40, 37, 45, 27, 20, 37, 16, 1, 12, 35, 19, 31, 8, 27,
  38, 20, 44, 19, 26, 13, 17, 23, 20, 20, 21, 2, 27, 1, 43, 1, 45, 20, 37, 30,
  6, 7, 18, 2, 1, 5, 14, 23, 27, 6, 24, 21, 8, 3, 21, 2, 32, 41, 41, 27, 45, 42,
  26, 26, 7, 33, 0, 12, 0, 22, 12, 42, 5, 31, 32, 4, 0, 31, 4, 13, 43, 20, 18,
  27, 14, 3, 21, 38, 31, 42, 27, 11, 44, 28, 38, 38, 41, 39, 9, 36, 42,
];

const abcLen = ABC.length;
const aascii = "A".charCodeAt(0);
const crange = "Z".charCodeAt(0) - aascii + 2; // we want to use A as 1 not 0

const ACCN_TYPE = Object.freeze({
  0: "NUMBER_ONLY",
  1: "MAX_4_CHARS_7_NUMS",
  NUMBER_ONLY: 0,
  MAX_4_CHARS_7_NUMS: 1,
});

let seed = 0;
function random(n) {
  if (typeof n === "number") seed = n;
  else return BigInt(rnd46x512[seed++ % 255]);
}

function swapBits(n, p1, p2) {
  /* Move p1'th to rightmost side */
  const bit1 = (n >> p1) & 1n;

  /* Move p2'th to rightmost side */
  const bit2 = (n >> p2) & 1n;

  /* XOR the two bits */
  let x = bit1 ^ bit2;

  /* Put the xor bit back to
    their original positions */
  x = (x << p1) | (x << p2);

  /* XOR 'x' with the original
    number so that the
    two sets are swapped */
  const result = n ^ x;
  return result;
}

function shuffle(i, crc) {
  random(crc);
  let swaps = 0;
  let tries = 0;
  const bitsSwaped = new Set();
  while (swaps < 20 && tries < 256) {
    ++tries;
    const p1 = random();
    if (bitsSwaped.has(p1)) continue;
    const p2 = random();
    if (bitsSwaped.has(p2)) continue;
    //console.log(i.toString(2), p1, p2);
    i = swapBits(i, p1, p2);
    ++swaps;
    bitsSwaped.add(p1);
    bitsSwaped.add(p2);
    //console.log(i.toString(2));
  }
  //console.log('swaps', swaps, tries);
  return i;
}

export function encode(accn_str, ch = 4, num = 7) {
  const re_num_only = /^(?<nums>\d+)$/;
  const re_chars_nums = /^(?<chars>\D*)(?<nums>\d+)$/;
  let type;

  let match = accn_str.match(re_num_only);
  if (match) {
    type = ACCN_TYPE.NUMBER_ONLY;
  } else {
    match = accn_str.toUpperCase().match(re_chars_nums);
    if (
      !match ||
      !match.groups.nums ||
      match.groups.nums.length > num ||
      match.groups.chars?.length > ch
    )
      throw new Error(`invalid ACCN format '${accn_str}'`);
    type = ACCN_TYPE.MAX_4_CHARS_7_NUMS;
  }

  let nums = parseInt(match.groups.nums);
  // console.log(nums);
  if (match.groups.chars) {
    const chars = match.groups.chars;
    for (let i = 0; i < chars.length; ++i) {
      const n =
        (chars.charCodeAt(chars.length - i - 1) - aascii + 1) *
        Math.pow(crange, i) *
        Math.pow(10, num);
      //   console.log(
      //     chars.charCodeAt(i) - aascii + 1,
      //     Math.pow(crange + 1, i),
      //     n.toString().padStart(14, ' '),
      //     nums + n
      //   );
      nums += n;
    }
  }

  return { type: type, val: nums };
}

export function decode(accn_num, ch = 4, num = 7) {
  if (ch === 0) return accn_num.toString();

  let cstr = "";
  for (let i = ch - 1; i >= 0; --i) {
    const n = //Math.trunc(
      accn_num / BigInt(Math.pow(crange, i)) / BigInt(Math.pow(10, num));
    //);
    /* console.log(
      n,
      Math.pow(crange + 1, i),
      accn_num // - n * Math.pow(crange + 1, i) * Math.pow(10, num)
    ); */
    if (n > 0) {
      const c = String.fromCharCode(Number(n) + aascii - 1);
      //console.log(i, c);
      cstr = cstr.concat(c);
      accn_num -= n * BigInt(Math.pow(crange, i)) * BigInt(Math.pow(10, num));
    }
  }
  const nums = accn_num;

  return cstr + nums.toString().padStart(7, "0");
}

export function toTriplets(n, bitLen) {
  const groupSize = 3;
  const tBitLen = Math.trunc(Math.log2(Math.pow(abcLen, groupSize)));
  const tNeeded = Math.ceil(bitLen / tBitLen);
  /* console.log(
    abcLen,
    'tBitLen',
    tBitLen,
    tNeeded,
    tNeeded * tBitLen,
    Math.log2(Math.pow(abcLen, groupSize))
  ); */
  let bits = n.toString(2).padStart(tNeeded * tBitLen, "0");
  //console.log(bits, bits.length, tBitLen, tNeeded);
  let res = [];
  for (let i = tNeeded; i > 0; --i) {
    const bs = bits.substr((i - 1) * tBitLen, tBitLen);
    //console.log(bs);
    let tn = parseInt(bs, 2);
    let r = "";
    for (let j = groupSize - 1; j >= 0; --j) {
      const a = Math.trunc(tn / Math.pow(abcLen, j));
      // console.log('j', j, 'a', a, ABC[a], 'pow j', Math.pow(abcLen, j));
      r = r.concat(ABC[a]);
      tn -= a * Math.pow(abcLen, j);
    }
    res.push(r);
    // console.log(r, tn);
  }
  res.reverse();
  // res = [res[2], res[3], res[0], res[1]];
  return res;
}

export function fromTriplets(strArray, bitLen) {
  const groupSize = 3;
  const tBitLen = Math.trunc(Math.log2(Math.pow(abcLen, groupSize)));
  const tNeeded = Math.ceil(bitLen / tBitLen);
  // console.log(tBitLen);
  let strArr = [...strArray].reverse();
  //assert(strArr.length === tNeeded);
  //strArr = [strArr[2], strArr[3], strArr[0], strArr[1]];

  let res = 0n;

  for (let i = 0; i < strArr.length; ++i) {
    const str = strArr[i];
    let t = 0n;
    // console.log(str, res);
    for (let j = 0; j < str.length; ++j) {
      const n = ABC.findIndex((a) => a === str[j]);
      t += BigInt(n * Math.pow(abcLen, str.length - j - 1));
      /* console.log(
        'j',
        j,
        'n',
        n,
        'n pow',
        Math.pow(abcLen, str.length - j - 1),
        'str[j]',
        str[j]
      ); */
    }
    res += t * BigInt(Math.pow(2, i * tBitLen)); // 2n << BigInt(i*tBitLen) doesn't work
  }
  return res;
}

let crc8Table = [];

function gen8table(type) {
  const CRC8_POLY = {
    CRC8: 0xd5,
    CRC8_CCITT: 0x07,
    CRC8_DALLAS_MAXIM: 0x31,
    CRC8_SAE_J1850: 0x1d,
    CRC_8_WCDMA: 0x9b,
  };

  const polynomial = CRC8_POLY[type];
  crc8Table = new Array(256);

  for (let i = 0; i < 256; ++i) {
    let curr = i;
    for (let j = 0; j < 8; ++j) {
      if ((curr & 0x80) !== 0) {
        curr = ((curr << 1) ^ polynomial) % 256;
      } else {
        curr = (curr << 1) % 256;
      }
    }
    crc8Table[i] = curr;
  }
}

function crc8(i, type = "CRC8_CCITT") {
  if (crc8Table.length == 0) {
    gen8table(type);
  }

  const ib = new ArrayBuffer(8);
  const dv = new DataView(ib);

  dv.setBigUint64(0, BigInt(i));

  let crc = 0x00;

  for (let i = 0; i < dv.byteLength; ++i) {
    crc = crc8Table[crc ^ dv.getUint8(i) % 256];
    //console.log(crc)
  }
  return crc;
}

const bitlen = 44n; //
const bitlen_calc = BigInt(
  Math.ceil(Math.log2(Math.pow(crange, 4) * Math.pow(10, 7)))
); // need round up to byte size
//console.log("bitlen calc", bitlen_calc);
const mask = (1n << (bitlen + 2n)) - 1n;
const mask_type = 3n << bitlen;

export function fromACCNToCode(accn) {
  let { type: t, val: e } = encode(accn);
  e = BigInt(e);
  const crc = crc8(e);
  e += BigInt(t) << bitlen;
  const shufe = shuffle(e, crc);
  const fileName = (BigInt(crc) << (bitlen + 2n)) + shufe;
  //console.log(fileName.toString(2))
  const triplets = toTriplets(fileName, Number(bitlen) + 8 + 2);

  //console.log(accn, e, crc, shufe, fileName, triplets);
  return { fileName: fileName, triplets: triplets };
}

export function fromCodeToACCN(triplets) {
  const fileName = BigInt(fromTriplets(triplets, Number(bitlen) + 8 + 2));
  const e = fileName & mask;
  const ncrc = Number(fileName >> (bitlen + 2n));
  let ne = shuffle(e, ncrc);
  const t = Number((ne & mask_type) >> bitlen);
  ne = ne - (ne & mask_type);
  let d;
  if (t === ACCN_TYPE["MAX_4_CHARS_7_NUMS"]) d = decode(ne);
  else {
    d = decode(ne, 0);
    while (d.charAt(0) === "0") d = d.substring(1);
  }
  const crc = crc8(ne);

  return { accn: d, fileName: fileName, crcOK: crc === ncrc };
}

function test() {
  console.log("bitlenght", bitlen, mask.toString(2));
  const accns = [
    "AAAA0000001",
    "A0000001",
    "A0000002",
    "B0000001",
    "ABC1234567",
    "ABC1234568",
    "AZP1234567",
    "ZZZZ9999999",
    "ZZZ9999998",
    "SSS1234567",
    "SZL5486253",
    "SZL8999999",
    "SZL0078435",
    "SZL0078437",
    "SZL0078438",
    "ZZL5486253",
    "10718142",
    "19722334",
    "1972233",
    "1",
    "2",
    "17592186044415",
    "10812012",
  ];
  for (const acn of accns) {
    const e = fromACCNToCode(acn);
    const d = fromCodeToACCN(e.triplets);

    console.log(
      acn.padEnd(12),
      e.fileName.toString().padEnd(18),
      e.triplets.join("-")
    );

    //assert(d.crcOK && e.fileName === d.fileName && d.accn === acn);
  }

  return;

  while (true) {
    let acn = "";
    let chars = 0;
    for (let i = 0; i < 4; ++i) {
      if (Math.random() > 0.8) break;
      acn += String.fromCharCode(
        Math.floor(Math.random() * (crange - 2)) + aascii
      );
      ++chars;
    }

    const nums = chars === 0 ? Math.round(Math.random() * 12) + 1 : 7;
    for (let i = 0; i < nums; ++i) acn += Math.floor(Math.random() * 9);
    if (chars === 0) while (acn.charAt(0) === "0") acn = acn.substring(1);
    if (!acn) continue;
    // console.log(acn, chars, nums);
    const e = fromACCNToCode(acn);
    const d = fromCodeToACCN(e.triplets);
    console.log(acn /* , e.triplets.join('-') */);
    assert(d.crcOK && e.fileName === d.fileName && d.accn === acn);
  }
}

function genRandTable() {
  for (let i = 0; i < 512; ++i) {
    process.stdout.write(
      Math.floor(Math.random() * (Number(bitlen) + 2)).toString() + ", "
    );
  }
}

//genRandTable();

//console.log('crange', crange);

// const max = encode('ZZZZ9999999');
// const tr = toTriplets(max, 51);
// console.log('------------------------');
// const trr = fromTriplets(tr, 51);
// console.log(max, tr, trr, decode(trr));
